import { useState } from "react";
import Logger from "../Logger";
import { getLoggerBaseURL } from "../../utils/getLoggerBaseURL";

const Popup = ({ selectedDriver, closePopup }) => {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [driverActivity, setDriverActivity] = useState([]);

  const logger = new Logger(getLoggerBaseURL());

  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const years = [
    "2022",
    "2023",
    "2024",
    "2025",
    "2026",
    "2027",
    "2028",
    "2029",
    "2030",
  ];

  const closeModal = () => {
    closePopup();
    setSelectedMonth("");
    setSelectedYear("");
    setDriverActivity([]);
  };

  const generateActivityData = async (month, year) => {
    try {
      const targetMonth =
        year && month
          ? `${year}-${month}`
          : new Date().toISOString().slice(0, 7);

      const data = {
        month: targetMonth,
        driverId: selectedDriver.driverId,
      };

      const response = await fetch(
        `/api/driverTesting/getMonthlyDriverReport/${selectedDriver.email}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
          credentials: "include",
        },
      );

      const result = await response.json();
      setDriverActivity(result?.monthlyRecord);
    } catch (error) {
      logger.log(`Error fetching driver activity: ${error}`, "ERROR");
    }
  };

  const handleMonthChange = (event) => {
    const month = event.target.value;
    setSelectedMonth(month);
    if (selectedYear) generateActivityData(month, selectedYear);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (selectedMonth) generateActivityData(selectedMonth, year);
  };

  const showActivity = selectedMonth && selectedYear;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
      <div
        className={`bg-white rounded-lg shadow-lg transition-all duration-300 
        ${showActivity ? "w-[700px] h-auto" : "w-[400px] h-auto"} 
        max-w-full p-4 pb-1 flex flex-col`}
      >
        <h1 className="text-lg font-bold mb-2">Driver Details</h1>

        <div className="flex-1 ">
          <div
            className={`grid ${
              showActivity ? "grid-cols-2" : "grid-cols-1"
            } gap-2 mb-2 text-sm`}
          >
            <p>
              <strong>Name:</strong> {selectedDriver.name}
            </p>
            <p>
              <strong>Email:</strong> {selectedDriver.email}
            </p>
            <p>
              <strong>Phone:</strong> {selectedDriver.phone}
            </p>
            <p>
              <strong>Working Hours:</strong> {selectedDriver.workingHours}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-2 text-sm">
            <div>
              <label className="font-medium">Month</label>
              <select
                value={selectedMonth}
                onChange={handleMonthChange}
                className="w-full mt-1 p-1 border rounded-md"
              >
                <option value="">-- Select Month --</option>
                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="font-medium">Year</label>
              <select
                value={selectedYear}
                onChange={handleYearChange}
                className="w-full mt-1 p-1 border rounded-md"
              >
                <option value="">-- Select Year --</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {showActivity && (
            <div className="p-3 border rounded-md bg-gray-100 max-h-[220px] overflow-y-auto">
              <h3 className="font-semibold text-sm mb-3">
                Activity for{" "}
                {months.find((m) => m.value === selectedMonth)?.label}{" "}
                {selectedYear}
              </h3>

              <table className="w-full text-sm border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="py-2 px-3 border">Date</th>
                    <th className="py-2 px-3 border">Hours</th>
                    <th className="py-2 px-3 border">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {driverActivity.length === 0 ? (
                    <tr>
                      <td colSpan="3" className="py-2 px-3 border text-center">
                        No activity found
                      </td>
                    </tr>
                  ) : (
                    driverActivity.map((activity, index) => (
                      <tr key={index}>
                        <td className="py-2 px-3 border">{activity.date}</td>
                        <td className="py-2 px-3 border">
                          {activity.workingHours} hrs
                        </td>
                        <td className="py-2 px-3 border">
                          {activity.workingHours[1] >= 5
                            ? "Full Day "
                            : "Half Day"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="mt-1 flex justify-center">
          <button
            onClick={closeModal}
            className="bg-[#79c6e9] text-white border border-[#79c6e9] rounded px-5 py-2 text-[15px] cursor-pointer h-[36px]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
